import styled from 'styled-components';

import { COLORS, HOME, MOBILE, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** The breakdown under the tiles: the tiles' inner panel fill. */
export const Frame = styled.div`
  background: ${HOME.panel};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  padding: ${SPACE[16]};
  min-width: 0;
`;

export const Title = styled(Text)`
  margin: ${SPACE[0]};
  font-size: 15px;
  font-weight: 600;
  color: ${HOME.t300};
`;

export const Sub = styled(Text)`
  font-size: 13px;
  line-height: 1.4;
  color: ${HOME.t400};
`;

/** Scrolls sideways on a narrow phone instead of widening the page. */
export const Scroll = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid ${COLORS.hairline};
  border-radius: 12px;
  overflow: hidden;
  font-size: 13px;
`;

export const HeadCell = styled.th<{ $num?: boolean }>`
  padding: ${SPACE[8]} ${SPACE[12]};
  text-align: ${({ $num }) => ($num ? 'right' : 'left')};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${COLORS.textFaint};
  white-space: nowrap;
  background: ${COLORS.surfaceInset};

  ${MOBILE} {
    padding: ${SPACE[8]};
  }
`;

export const Row = styled.tr`
  background: ${COLORS.surfaceFaint};
`;

export const RowHead = styled.th`
  padding: ${SPACE[8]} ${SPACE[12]};
  border-top: 1px solid ${COLORS.hairline};
  text-align: left;
  font-weight: 500;
  color: ${COLORS.text};
  white-space: nowrap;

  ${MOBILE} {
    padding: ${SPACE[8]};
  }
`;

export const Cell = styled.td`
  padding: ${SPACE[8]} ${SPACE[12]};
  border-top: 1px solid ${COLORS.hairline};
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  color: ${COLORS.text};
  white-space: nowrap;

  ${MOBILE} {
    padding: ${SPACE[8]};
  }
`;

/** The quiet `not enabled` tag after a row name. */
export const Off = styled(Text)`
  margin-left: ${SPACE[8]};
  font-size: 12px;
  font-weight: 400;
  color: ${HOME.t500};
`;

export const Note = styled(Text)`
  margin: ${SPACE[0]};
  font-size: 12px;
  line-height: 1.4;
  color: ${HOME.t500};
`;

export const Toggle = styled.div`
  display: flex;
  justify-content: flex-start;
`;
